export const OPENSEA_VAULT_URI = "https://opensea.io/the_vault";
export const NFTSTUDIOS_URI = "https://sidxo.com/";

export const PREVIEW_ACCESS = "preview";
